var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.5C16 11.0906 12.4187 14 7.99995 14C6.84058 14 5.74057 13.8 4.74682 13.4406C4.37495 13.7125 3.7687 14.0844 3.04995 14.3969C2.29995 14.7219 1.39683 15 0.49995 15C0.296825 15 0.115575 14.8781 0.0374502 14.6906C-0.0406748 14.5031 0.00307515 14.2906 0.1437 14.1469L0.153075 14.1375C0.16245 14.1281 0.17495 14.1156 0.1937 14.0938C0.228075 14.0562 0.2812 13.9969 0.346825 13.9156C0.47495 13.7594 0.646825 13.5281 0.821825 13.2406C1.13433 12.7219 1.4312 12.0406 1.49058 11.275C0.553075 10.2125 -4.98406e-05 8.90938 -4.98406e-05 7.5C-4.98406e-05 3.90937 3.5812 1 7.99995 1C12.4187 1 16 3.90937 16 7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.6d1f98d98b7cfb00ee667c56ed46db00.svg";
export { ForwardRef as ReactComponent };